import client from '@/base-http'
import MenuEntry from '../model/MenuEntry';
import Slot from '../model/Slot';
import _ from 'lodash'
import { ApiError } from '@/api';

/**
 * Permite obtener una lista de menus registrados
 */
export async function getMenuList () {
    const data = (await client.get('cms/menus')).data
    if (!Array.isArray(data)) {
        throw new Error(`Se esperaba un array pero se obtuvo ${typeof data}`)
    }

    return data.map(m => MenuEntry.deserialize(m))
}


/**
 * Permite obtener un menu completo
 *
 * @param id
 */
export async function getMenu (id: number) {
    try {
        return MenuEntry.deserialize((await client.get(`cms/menus/${id}`)).data)
    } catch (err) {
        throw ApiError.fromResponse(err)
    }
}

/**
 * Obtiene la lista de posiciones disponibles para registrar en el servidor
 */
export async function getSlotList () {
    const data = (await client.get('cms/menu/slots')).data
    if (!Array.isArray(data)) {
        throw new Error(`Se espera un array con la lista de slots se obtuvo ${typeof data}`)
    }

    return data.map(s => Slot.deserialize(s))
}

/**
 * Registra un nuevo menú en la aplicación
 *
 * @param menu
 */
export async function createMenu (menu: MenuEntry) {
    const data = (await client.post('cms/menu', menu.serialize())).data

    return MenuEntry.deserialize(data)
}

/**
 * Actualiza la información de un menú en la aplicación
 *
 * @param menu
 */
export async function updateMenu (menu: MenuEntry) {
    if (menu.isNew) {
        throw new Error('No se puede actualizar un menú que aún no ha sido creado')
    }

    const data = (await client.put(`cms/menu/${menu.id}`, menu.serialize())).data

    return MenuEntry.deserialize(data)
}

/**
 * Elimina un menú de la aplicación
 * @param id
 */
export async function deleteMenu (id: number) {
    const data = (await client.delete(`cms/menu/${id}`)).data

    return _.get(data, 'sucess', false)
}
